import ReactDOM from "react-dom/client";
import { MantineProvider } from '@mantine/core';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import NoPage from "./pages/NoPage";
import HeaderResponsive from "./pages/HeaderResponsive"
import FooterBlock from "./pages/FooterBlock";
import About from "./pages/About";
import { NotificationsProvider } from '@mantine/notifications';

export default function App() {
  return (
    <BrowserRouter>
      <HeaderResponsive />
      <Routes>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NoPage />} />
      </Routes>
      <FooterBlock />
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MantineProvider withGlobalStyles withNormalizeCSS theme={{
    colors: {
      'tractor-green': ["#84B683","#56A654","#3D8D3B","#297927","#196917","#0C5C0A","#025200","#073706","#092608","#091A08","#081208","#070D07","#050905"],
    },
    primaryColor: 'tractor-green',
    spacing: { xs: 20, sm: 24, md: 32, lg: 40, xl: 48 }
  }}>
    <NotificationsProvider position="top-center" zIndex={2077}/>
    <App />
  </MantineProvider>);